export let Spec = /*#__PURE__*/function (Spec) {
  Spec["ProGallery"] = "specs.siteSearch.ProGallery";
  Spec["UseWarmupData"] = "specs.siteSearch.UseWarmupData";
  Spec["SkipNavigationStep"] = "specs.siteSearch.SkipNavigationStep";
  Spec["ChangeSelectedTabInEditorOnEdit"] = "specs.siteSearch.ChangeSelectedTabInEditorOnEdit";
  Spec["NewSearchOnClassicEditor"] = "specs.siteSearch.NewSearchOnClassicEditor";
  Spec["UpgradeToNewSearch"] = "specs.siteSearch.UpgradeToNewSearch";
  Spec["ReplaceSearchBoxToSearchButton"] = "specs.siteSearch.ReplaceSearchBoxToSearchButton";
  Spec["ShowStudioUpdateFlow"] = "specs.siteSearch.ShowStudioUpdateFlow";
  return Spec;
}({});
//# sourceMappingURL=specs.js.map